import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "list", "view", "3333", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `operations--products--clinics--regularizations--partners--dashboard`
  }

  doPartnersDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-8 pr-1" data-${this.controllerName}-target="list" data-controller="operations--products--clinics--regularizations--partners--index"></div>
                  <div class="col-4 pl-1" data-${this.controllerName}-target="view" data-controller="operations--products--clinics--regularizations--partners--save operations--products--clinics--regularizations--partners--show"></div>
                </div>`

    // this.getControllerByIdentifier("operations--products--clinics--regularizations--show--main").contentTarget.innerHTML = html
    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier(`operations--products--clinics--regularizations--show--main`).contentTarget.innerHTML = html)
    }).then(() => {
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--show--submenu`).dashboardToggleBtn(`QUADRO SOCIETÁRIO`)

      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--partners--index`).permission = `medclinic_regularization_partners`
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--partners--show`).permission = `medclinic_regularization_partners`
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--partners--show`).info_permission = `medclinic_regularization_partner_infos`
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--partners--show`).contact_permission = `medclinic_regularization_partner_contacts`
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--partners--show`).profile_permission = `medclinic_regularization_partner_profiles`
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--partners--save`).permission = `medclinic_regularization_partners`

      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--partners--index`).doIndexListHtml()
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--partners--show`).doViewHtml()
    }) 
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
